import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null,
    person: null,
  },
  mutations: {
    //用户信息
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
      // localStorage.setItem('userInfo',Base64.encode(JSON.stringify(userInfo)))
      localStorage.setItem('userInfo',JSON.stringify(userInfo))
    },
    clearUserInfo (state) {
      state.userInfo = null;
      localStorage.removeItem('userInfo')
    },
    setPerson (state, person) {
      state.person = person;
      localStorage.setItem('person',JSON.stringify(person))
    }
  },
  actions: {
    setUserInfo (context, userInfo) {
      context.commit('setUserInfo', userInfo)
    },
    clearUserInfo (context) {
      context.commit('clearUserInfo')
    },
    setPerson (context, person) {
      context.commit('setPerson', person)
    }
  },
  getters: {
    getUserInfoStorage (state) {
      if(!state.userInfo){
        if(localStorage.getItem('userInfo')){
          // state.userInfo = JSON.parse(Base64.decode(localStorage.getItem('userInfo')))
          state.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        }

      }
      return state.userInfo
    },
    getPersonStorage (state) {
      if(!state.person){
        if(localStorage.getItem('person')){
          // state.userInfo = JSON.parse(Base64.decode(localStorage.getItem('userInfo')))
          state.person = JSON.parse(localStorage.getItem('person'))
        }

      }
      return state.person
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js